import React from 'react';
import { toTitleCase } from 'src/utilities/string-utils';
import { CreditCardIcon } from 'src/components/common/CreditCardIcon/CreditCardIcon';
import { BalanceCardBrand } from 'src/types/Balance';
import { formatExpirationDate } from 'src/components/selfService/common/Balance/utils/creditCardUtils/formatExpirationDate';
import { BasePaymentMethodDisplay } from 'src/components/selfService/common/Balance/components/BasePaymentMethodDisplay/BasePaymentMethodDisplay';

export interface CreditCardDisplayProps {
  brand: BalanceCardBrand;
  expiration: {
    month: number;
    year: number;
  };
  lastFourDigits: string;
  isDefault: boolean;
  showBorder?: boolean;
}

export function CreditCardDisplay({
  brand,
  expiration: { month, year },
  lastFourDigits,
  isDefault,
  showBorder = true,
}: CreditCardDisplayProps): JSX.Element {
  const expirationDate = formatExpirationDate(month, year);
  const cardDetails = `${toTitleCase(brand)} •••• ${lastFourDigits}`;

  return (
    <BasePaymentMethodDisplay
      icon={<CreditCardIcon cardBrand={brand} />}
      primaryText={cardDetails}
      secondaryText={`Expires ${expirationDate}`}
      isDefault={isDefault}
      showBorder={showBorder}
    />
  );
}
